import GlobalModal from "components/Modal/GlobalModal";
import { PropertyContactFormProps } from "./types";
import styles from './contact.module.css';
import PropertyUpgrade from "components/Modal/PropertyUpgrade";

/**
  ModalContactForm
  This component does not manage its own state, that needs to happen in the parent component.
  @param id string.
  @param form array, describes the structure of the form and supplies the state to each element.
  @param modal ? settings for the modal
  @param Header ? component to show above the form
  @param Footer ? component to show below the form
*/
const ModalContactForm = (contactFormProps: PropertyContactFormProps) => {
  const { isOpen, closeModal} = contactFormProps.modal;
  const { property } = contactFormProps;

  const propertyName = [property.name,
  property?.address?.line1,
  property?.address?.line2,
  property?.address?.town_name,
  property?.address?.postcode].filter(Boolean).join(', ');

  let newClasses = {
    portalclassname: "ContactFormPortal",
    overlayclassname: "ContactForm__Overlay",
    className: `${styles.ContactForm__Content} ${styles.Property_contact}`,
    bodyopenclassname: "ContactForm__Body--open",
    htmlopenclassname: "ContactForm__Html--open",
  };

  if (!isOpen) return null;
  return (
    <GlobalModal
      isOpen={isOpen}
      modalClasses={newClasses}
      close={closeModal} id={""}      >
     <button className={styles.CloseModal} onClick={closeModal}>
        <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/cross-grey-2.svg`} alt="Close Modal" />
      </button>

      <PropertyUpgrade
        closeModal={closeModal}
        emailSubject={`Upgrade -  ${propertyName}`}
        emailTemplate="retail"
        title="Upgrade"
        property={property} subTitle={""}      
        />
    </GlobalModal>
  );
};

export default ModalContactForm;
